import React, { useEffect } from "react";
import styled from "@emotion/styled";
import CountryFlags from "../../utils/countryFlags";
import { truncateToTwo } from "../../utils/NumberUtility";

export function PedidoResumoList(props: { data }) {
  const [total, setTotal] = React.useState(0);
  const [name, setName] = React.useState("");

  useEffect(() => {
    const data = props.data;
    let total = 0;
    let name = ""
    data.forEach(element => {
      total += parseFloat(parseFloat(element.Total).toFixed(2));
      name += `${element.Tipo.split(" ")[0]}, `;
    });
    setName(name.slice(0, -2));
    setTotal(total)
    console.log(total)
  }, [props.data])
  return (
    <Container>
      <Pedidos>
        <CountryFlags cod={props.data[0].Tipo.split(" ")[0]} />
        <div className="tipoMoeda">
          <p className="moeda">{name}</p>
          <p className="moeda">
            {truncateToTwo(total).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })}
          </p>
            <a
              className="ver-pedido"
              href={`/om/painel/perfil/meus-pedidos`}
            >
              Ver Pedidos
            </a>
        </div>
      </Pedidos>
      <DivButton>
          <p>Em Andamento</p>
      </DivButton>
    </Container>
  );
}

const Container = styled.div`
  font-family: var(--bs-body-font-family);
  border: 1px solid;
  border-radius: 8px;
  padding: 30px 20px;
  margin-top: 50px;
  font-size: 15px;
  font-weight: 500;
  color: #a9a9a9;

  img {
    width: 120px;
  }

  @media (min-width: 780px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 760px;
  }
`;
const Pedidos = styled.div`
  display: flex;
  justify-content: space-evenly;

  .tipoMoeda {
    margin: 0 0 0 5px;
  }

  .tipoMoeda > .moeda {
    margin: 0;
    color: rgb(0, 65, 51);
    font-weight: 600;
    text-transform: uppercase;
  }
  .ver-pedido {
    color: rgb(0, 65, 51);
    text-decoration: none;
  }

  @media (min-width: 800px) {
    .tipoMoeda {
      margin: 0 30px 0 5px;
    }
  }
`;

const DivButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    color: rgb(0, 65, 51);
    margin-top: 5px;
    margin-bottom: 0;
  }
`;

const Button = styled.button`
  color: var(--primary-white);
  background-color: var(--green);
  border: none;
  border-radius: 5px;
  width: 150px;
  height: 45px;
  margin: 35px auto 0;

  @media (min-width: 780px) {
    margin: 0;
  }
`;
